import { useEffect, useState } from "react";

/** A status line that clears itself after a few seconds — the transient
 *  "Saved …" notice used across panels. */
export function useTransientStatus(
  timeoutMs = 4000,
): [string | null, (status: string | null) => void] {
  const [status, setStatus] = useState<string | null>(null);
  useEffect(() => {
    if (!status) return;
    const timer = setTimeout(() => setStatus(null), timeoutMs);
    return () => clearTimeout(timer);
  }, [status, timeoutMs]);
  return [status, setStatus];
}
